import { useTranslation } from 'react-i18next';
import { columnsWidth } from 'components/molecules/rpm-overview-table/constants';
import { type FC } from 'react';
import { useAssignPatient } from 'infrastructure/hooks/rpm/assign-tool/use-set-assign-patient';
import useUser from 'utils/useUser';
import { useCountdownTimer } from 'infrastructure/hooks/use-count-down-timer';
import BaseButton from 'components/atoms/baseButton';

import s from './styles.module.scss';

import type { IAssignee } from 'infrastructure/interfaces';

interface AssignCellProps {
  patientGuid: string;
  assignee?: IAssignee;
}
const AssignCell: FC<AssignCellProps> = ({ patientGuid, assignee }) => {
  const { t } = useTranslation();
  const { loginGuid } = useUser();
  const { isMobileDevice } = useUser();
  const { assignPatient, isLoading } = useAssignPatient();

  const isAssignedToOther = assignee && assignee.loginGuid !== loginGuid;
  const isAssignedToMe = assignee && assignee.loginGuid === loginGuid;
  const endTime = assignee?.expireAtTimestamp
    ? new Date(assignee.expireAtTimestamp)
    : undefined;

  useCountdownTimer({
    endTime,
    onFinish: () => {
      assignPatient({ patientGuid, action: 'unassign', silentUpdate: true });
    },
  });

  const label =
    assignee && isAssignedToMe ? t('labels.unassign') : t('labels.assign');

  const assignedToMeTitle = isAssignedToMe
    ? t('labels.assignedToMe')
    : undefined;
  const isAssignedToOtherTitle = isAssignedToOther
    ? assignee?.fullName
    : undefined;

  const assignedTitle = assignedToMeTitle ?? isAssignedToOtherTitle;

  const handleUnassign = async () => {
    if (!assignee || isAssignedToOther) return;

    assignPatient({ patientGuid, action: 'unassign' });
  };
  const handleAssign = async () =>
    assignee && isAssignedToMe
      ? handleUnassign()
      : assignPatient({ patientGuid, durationInMinutes: 60, action: 'assign' });

  return (
    <div
      className={s.wrapper}
      style={{ width: isMobileDevice ? 100 : columnsWidth.assign }}
    >
      <BaseButton
        label={label}
        type="secondary"
        disabled={isLoading || !!isAssignedToOther}
        loading={isLoading}
        onClick={handleAssign}
        className={s['assign-button']}
        title={assignedTitle}
      />
    </div>
  );
};
export default AssignCell;
